import { useContext, useEffect } from "react";
import DataContext from "../context/DataContext";

/**
 * Custom hook to handle homePath logic with localStorage
 * @param {String} bUser - the currrent business user
 * @returns {String} - the current business user
 */
const useCurrentBU = (bUser) => {
    const { currentBU, setCurrentBU } = useContext(DataContext);

    useEffect(() => {
        setCurrentBU(setCurrentBU !== bUser && bUser);
    }, [bUser, currentBU, setCurrentBU]);

    return currentBU;
};

export default useCurrentBU;
